import dayjs from 'dayjs';
import { Contract, ContractItemPriceRaise, ContractItemPriceRaiseStatus } from '../../model/types';

export const isNextInvoiceUnderAcceptedPriceRaise = (contract?: Contract, priceRaises?: ContractItemPriceRaise[]): boolean => {
  if (!contract?.chargedTo || contract.invoiceLeadDays == null || !priceRaises?.length) {
    return false;
  }

  const nextInvoiceIssueDate = dayjs(contract.chargedTo).startOf('day').subtract(contract.invoiceLeadDays, 'day');

  if (!nextInvoiceIssueDate.isValid()) {
    return false;
  }

  return priceRaises.some((priceRaise) => {
    if (priceRaise.status !== ContractItemPriceRaiseStatus.ACCEPTED || !priceRaise.priceRaiseDate) {
      return false;
    }

    const priceRaiseDate = dayjs(priceRaise.priceRaiseDate).startOf('day');

    return priceRaiseDate.isValid() && !nextInvoiceIssueDate.isBefore(priceRaiseDate, 'day');
  });
};
